export enum RosterApprovalStatus {
  REJECTED = 0,
  PENDING,
  APPROVED,
}
